import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC, useState } from "react";
import { HiChevronDown as ChevronDown } from "react-icons/hi";

import { FAQs } from "./constants";
import styles from "./styles.module.scss";

const FAQ: FC = () => {
  const [selectedQuestion, setSelectedQuestion] = useState<null | string>(null);

  return (
    <Content contentClassName={styles.container}>
      <Media at={["desktop"]}>
        <Label className={styles.title} variant="h2-centered" color="primary">
          FAQ
        </Label>
      </Media>
      <Media at={["responsive"]}>
        <Label className={styles.title} variant="h1-centered" color="primary">
          FAQ
        </Label>
      </Media>
      <Label className={styles.subtitle} variant="s2-centered" color="primary">
        Check out our FAQ below for answers to commonly asked questions. Don’t
        find what you&apos;re looking for? Email us at hello@humminghomes.com
        and we’ll get back to you shortly!
      </Label>
      <Media at={["responsive"]}>
        <Label className={styles.support} variant="h2" color="primary">
          Support
        </Label>
      </Media>
      <div className={styles.faqs}>
        {FAQs.map(({ question, answer }) => (
          <Collapsable
            open={selectedQuestion === question}
            onSelect={(id: string) => {
              if (id === selectedQuestion) setSelectedQuestion(null);
              else setSelectedQuestion(id);
            }}
            id={question}
            className={styles.collapsable}
            header={
              <div className={styles.question}>
                <Label variant="s3" color="primary">
                  {question}
                </Label>
                <ChevronDown
                  className={`${styles.chevron} ${
                    selectedQuestion === question && styles.chevronUp
                  }`}
                />
              </div>
            }
          >
            <Label>{answer}</Label>
          </Collapsable>
        ))}
      </div>
    </Content>
  );
};

export default FAQ;
